import { render, staticRenderFns } from "./ItemLabels.vue?vue&type=template&id=6f27b5fd&scoped=true"
import script from "./ItemLabels.vue?vue&type=script&lang=js"
export * from "./ItemLabels.vue?vue&type=script&lang=js"
import style0 from "./ItemLabels.vue?vue&type=style&index=0&id=6f27b5fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f27b5fd",
  null
  
)

export default component.exports